/**
 * Centralized query keys for React Query
 * This file defines all query keys used in the client application.
 */

import type { ListCollectionItemsInput } from 'types/cms';

/**
 * Query keys for CMS-related queries
 */
export const cmsKeys = {
	all: ['cms'] as const,
	items: {
		all: () => [...cmsKeys.all, 'items'] as const,
		list: ({ collectionId, ...params }: ListCollectionItemsInput) =>
			[...cmsKeys.items.all(), 'list', collectionId, { params }] as const,
	},
};

/**
 * @example
 * Query keys for user-related queries
 */
// export const userKeys = {
//   all: ['user'] as const,
//   details: () => [...userKeys.all, 'details'] as const,
//   game: (storyId: string) => [...userKeys.all, 'game', storyId] as const,
// };
